import React from "react";
import News from "../Home/News.js";
import Contents from "../Home/Contents.js";
import news from "../json/news.json";
import contents from "../json/contents.json";

const Top = ({ setActiveScreen }) => {

    const result = news.slice(0,3);
    console.log(news);


    return (
        <div>
            <div className="top-welcome-message">
                <p className="top-welcome-text">This is AoyamaTaro's Website.</p>
            </div>
            <div className="top-message-wrapper">
                このサイトでは、アオヤマタロウの活動内容やこれまでの実績を紹介しています。<br />
                主に音楽制作、演奏活動、ウェブ開発を行っています。<br />
                <br />
                ご依頼やお問い合わせは、コンタクトフォームをご利用ください。<br />
            </div>

            <div className="news-title-wrapper">
                <p className="news-title-text">NEWS</p>
            </div>
            <div className="news-contents-wrapper-c">
                <div>
                    {result.map((item, index) => (
                        <div key={index}>
                            <News key={index}
                                date={item.date}
                                title={item.title}
                                contents={item.contents}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div className="news-title-wrapper">
                <p className="news-title-text">CONTENTS</p>
            </div>
            <div className="contents-contents-wrapper">
                <div>
                    {contents.map((item, index) => (
                        <div key={index}>
                            <Contents key={index}
                                name={item.name}
                                content={item.content}
                                screen={item.screen}
                                setActiveScreen={setActiveScreen}
                            />
                        </div>
                    ))}
                </div>

            </div>


        </div>
    );
}

export default Top;